import { EventEmitter, Injectable, Output } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { DashboardService } from '../../services/dashboard.service';
import { finalize, Observable, Subject, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SiteSelectionDialogComponent } from './site-selection-dialog/site-selection-dialog.component';
import { DateFilterDialogComponent } from './date-filter-dialog/date-filter-dialog.component';
import moment, { Moment } from 'moment';
import { AssetsFilterDialogComponent } from './assets-filter-dialog/assets-filter-dialog.component';
import {
    BreakpointObserver,
    Breakpoints,
    BreakpointState,
} from '@angular/cdk/layout';
import { DownloadReportDialogComponent } from './download-report-dialog/download-report-dialog.component';
import { AlertService } from 'app/shared/alert/alert.service';
import { TransitionCheckState } from '@angular/material/checkbox';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { VerificationStatusFilterDialogComponent } from './verification-status-filter-dialog/verification-status-filter-dialog.component';
import { SectionSelectionDialogComponent } from './section-selection-dialog/section-selection-dialog.component';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { ChainageFilterDialogComponent } from './chainage-filter-dialog/chainage-filter-dialog.component';
import { SelectSiteComponent } from '../select-site/select-site.component';
import { CategoryFilterDialogComponent } from './category-filter-dialog/category-filter-dialog.component';
import { Location } from '@angular/common';
import maplibregl from 'maplibre-gl';
import { environment } from 'environments/environment';
import * as L from 'leaflet';

@Injectable({
    providedIn: 'root',
})
export class ShiftDataService {
    public selectedShiftData: any = undefined;
    public allShiftData: any[] = [];
    public map: mapboxgl.Map;
    public mapBoxPopup = undefined;
    public _masterSites: any[] = [];
    public selectedMasterSite: any;
    public selectedSubSite: any;
    public masterSiteSelection: EventEmitter<any> = new EventEmitter();
    public masterSiteSelectionChange: EventEmitter<any> = new EventEmitter();
    public refreshChange: EventEmitter<any> = new EventEmitter();
    public chainageValuesChangeEmitter: EventEmitter<any> = new EventEmitter();
    public isLhs = true;
    public selectedAssetIdsForFilter = [];
    public selectedAssetIdsToEditSlaDays = [];
    // public selectedAssetIdsToUpdateSLADays  = [];
    public selectedAssetIds = [];
    selectedAssetIdsForExclusion = [];
    public onFilterChange = new EventEmitter();
    chainageHighValue: any;
    chainageLowValue: any;
    public periodFrom: any = undefined;
    public periodTo: any = undefined;
    filterStartDate: string = undefined;
    filterEndDate: string = undefined;
    public windowSizeChanged: EventEmitter<any> = new EventEmitter();
    public onNextClickEvent: EventEmitter<any> = new EventEmitter();
    public onPreviousClickEvent: EventEmitter<any> = new EventEmitter();
    public selectedDates: { startDate: Moment; endDate: Moment };
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isGoodSelected = false;
    //Asset filter dialog
    public filters: any[] = [];
    public filtersIsFromMaster = undefined;
    isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.XSmall
    );
    isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Small
    );

    defaultMinChainage: number;
    defaultMaxChainage: number;

    siteSelectionDialogRef: any;
    dateFilterDialogRef: any;
    assetFilterDialogRef: any;
    downloadDialogRef: any;
    /**change password */
    //changePasswordDialogRef :any;
    isInitialLoad: any = true;
    isUnique: boolean = true;
    dataFilterApplied: boolean = false;
    isLhsRhsToggled: boolean = false;
    verificationFilterDialogRef: any;
    verification_type: any[] = [];
    public workOrderVerificaiton: any;
    @Output() tabClickEvent: EventEmitter<void> = new EventEmitter<void>();
    selectedVerificationForFilter = [];
    sectionFilterDialogRef: any;
    sections: any = '';
    selectedSections: any[] = [];
    /*LHS RHS changes*/
    isShiftDataLHS: boolean = true;
    isShiftDataRHS: boolean = true;
    isMasterDataLHS: boolean = true;
    isMasterDataRHS: boolean = true;
    selectedSite: any[] = [];
    sitesCount: number = 0;
    hideIndicators: boolean = false;
    chainageValues: any;
    selectedChainageRanges: any = [];
    selectIssueType: any = [];
    selectedSiteSlaData: any = '';
    @Output() siteChangeEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() departmentDisplayEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() siteSelectionEvent: EventEmitter<void> = new EventEmitter<void>();
    editExclusion = new EventEmitter();
    isSLA: boolean = false;
    siteselectDialogOpen: boolean = false;
    /**button to mark given master as 'Not our Asset' */
    //public masterDataDeleted = new EventEmitter();
    selectedSiteToDisplaySiteDetails: string = '';
    siteTotalExclusions: any;
    lhsrhs: string = 'both';
    shoulder_median: string = 'both';
    period_from: any;
    period_to: any;
    fromChainageValue: any;
    toChainageValue: any;
    textInputValue: any; assetFilterByClickingOnAnomaly: boolean = false;
    assetFilterByClickingOnAsset: boolean = false;
    anomalySelectedIndex: number | null = null;
    assetSelectedIndex: number | null = null;
    masterID: any = '';
    anomalyID: any = '';
    public nextAssetDetails = new EventEmitter();
    selectedCategoryIdsForFilter = [];
    categoryFilterDialogRef: any;
    expandMap: EventEmitter<any> = new EventEmitter();
    isLeafLetMap: boolean = false;
    isMapBox: boolean = false;
    showMaps: boolean = false;
    isOpenStreetMap: boolean = false;
    @Output() loadMap = new EventEmitter<void>();
    popup: maplibregl.Popup | null = null;
    OSMap: any;
    public environment = environment;
    leafletMap!: L.Map;
    markerGroup!: L.LayerGroup;
    onLeafletMapMarkerClick = new EventEmitter();
    public leafletMarkersMap = new Map<string, L.CircleMarker>();
    masterSearch = {
        asset_ids: [],
        periodFrom: undefined,
        periodTo: undefined,
        minChainageValue: undefined,
        maxChainageValue: undefined,
        site_ids: undefined,
        chainage: undefined,
        equipment_id: undefined,
        category_ids: undefined,
        //Section filter changes 
        //section : undefined
    };
    displayAnomalyBreakdown: boolean = false;

    constructor(
        private dashboardService: DashboardService,
        private dialog: MatDialog,
        private breakpointObserver: BreakpointObserver,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private router: Router, public location: Location
    ) {
        let selectedMap: any = localStorage.getItem("selectedMap");
        if (selectedMap === "leafLetMap") {
            this.isLeafLetMap = true;
            this.isMapBox = false;
            this.isOpenStreetMap = false;
        }
        else if (selectedMap === "openStreet") {
            this.isLeafLetMap = false;
            this.isMapBox = false;
            this.isOpenStreetMap = true;
        }
        else {
            this.isLeafLetMap = false;
            this.isMapBox = true;
            this.isOpenStreetMap = false;
        }
        if (JSON.parse(localStorage.getItem('isUniqueButton')) !== null) {
            this.isUnique = JSON.parse(localStorage.getItem('isUniqueButton'));
        }
        localStorage.setItem('isUniqueButton', this.isUnique.toString());

        let currentPage = localStorage.getItem('currentPage');
        this.isSLA = ( currentPage === 'SLA' || currentPage === 'Exclusion' || currentPage === 'Reports' 
            || currentPage === 'Add New Users' || currentPage === 'Manage Users' ) ? true : false;
        let AnomalyID = localStorage.getItem("AnomalyID");
        if (AnomalyID != undefined && AnomalyID != '' && AnomalyID != null) {
            this.anomalyID = AnomalyID;
        }
        let MasterID = localStorage.getItem("MasterID");
        if (MasterID != undefined && MasterID != '' && MasterID != null) {
            this.masterID = MasterID;
        }
    }

    openSiteSelectionDialogComponent() {
        if(this.siteselectDialogOpen){
            this.dialog.closeAll();
        }
        this.siteselectDialogOpen = true;
        let dialogRef = this.dialog.open(SelectSiteComponent, {
            minWidth: '40%',
            hasBackdrop: false,
            closeOnNavigation: true,
        });
        dialogRef.afterClosed().subscribe(() => {
            let currentPage = localStorage.getItem('currentPage');
            this.isSLA = (currentPage.toLowerCase() === 'SLA'.toLowerCase() || currentPage.toLowerCase() === 'Exclusion'.toLowerCase() 
            || currentPage.toLowerCase() === 'Reports'.toLowerCase() || currentPage.toLowerCase() === 'Add New Users'.toLowerCase() || currentPage.toLowerCase() === 'Manage Users'.toLowerCase()) ? true : false;
            if (this.selectedSiteSlaData && this.selectedSiteSlaData.length === 0 && this.isSLA) {
                this.openSiteSelectionDialogComponent();
            }
            this.siteselectDialogOpen = false;

        });
    }

    onPreviousClick(loadNext: boolean = true) {
        let index = loadNext ? 1 : 0;
        let filteredData = this.allShiftData.filter(
            (anomaly) =>
                anomaly.dummy_id == +this.selectedShiftData.dummy_id - index
        );
        if (!filteredData.length) {
            return;
        }
        this.selectedShiftData = filteredData[0];
        this.getMarkerData(this.selectedShiftData);
    }

    onNextClick(loadNext: boolean = true) {
        let index = loadNext ? 1 : 0;
        let filteredData = this.allShiftData.filter(
            (anomaly) =>
                anomaly.dummy_id == +this.selectedShiftData.dummy_id + index
        );
        if (!filteredData.length) {
            return;
        }
        this.selectedShiftData = filteredData[0];
        this.getMarkerData(this.selectedShiftData);
    }

    public getMarkerData(data: any) {
        let search = { site_id: this.selectedSubSite.site_id };
        if (data.current_status > 1) {
            // shift data
            this.dashboardService
                .getShiftDataRecord(data.row_id, search)
                .subscribe(
                    (res: any) => {
                        this.selectedShiftData = res.responseData[0].records;
                        this.selectedShiftData.dummy_id = data.dummy_id;
                        this.selectedShiftData.current_status = 2;
                        if (this.isOpenStreetMap) {
                            this.onOSMMarkerClick(this.selectedShiftData);
                        }
                        else if (this.isMapBox) {
                            this.onMarkerClick(this.selectedShiftData);
                        }
                        else if (this.isLeafLetMap) {
                            this.onLeafletMapMarkerClick.emit(this.selectedShiftData);
                        }
                        this.nextAssetDetails.emit();
                    },
                    (error) => {
                        // this.alertService.error(
                        //     error.responseStatus.statusDescription
                        // );
                    }
                );
        } else {
            // master Data
            this.dashboardService.getSiteAssetInfo(data.id, search).subscribe(
                (res: any) => {
                    this.hideIndicators = res.responseData[0].records.image_path.length === 1 ? true : false;
                    this.selectedShiftData = res.responseData[0].records;
                    this.selectedShiftData.dummy_id = data.dummy_id;
                    this.selectedShiftData.current_status = 1;
                    this.selectedShiftData.latitude = Number(this.selectedShiftData.latitude).toFixed(4);
                    this.selectedShiftData.longitude = Number(this.selectedShiftData.longitude).toFixed(4);
                    this.selectedShiftData.master_image_path =
                        this.selectedShiftData.image_path;
                    if (this.isOpenStreetMap) {
                        this.onOSMMarkerClick(this.selectedShiftData);
                    }
                    else if (this.isMapBox) {
                        this.onMarkerClick(this.selectedShiftData);
                    }
                    else if (this.isLeafLetMap) {
                        this.onLeafletMapMarkerClick.emit(this.selectedShiftData);
                    }
                    this.nextAssetDetails.emit();
                },
                (error) => {
                    // this.alertService.error(
                    //     error.responseStatus.statusDescription
                    // );
                }
            );
        }
    }

    /* chainage on map */
    public onMarkerClick(data: any, isExpand: boolean = false, fromChainageMarker: boolean = false) {
        if (this.mapBoxPopup) {
            this.mapBoxPopup.remove();
        }

        let coordinates = [+data.longitude, +data.latitude];

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(coordinates[0] - coordinates[0]) > 180) {
            coordinates[0] += coordinates[0] > coordinates[0] ? 360 : -360;
        }
        const asset_name = this.dashboardService.translate(
            data.asset_name
        );
        const description = `<strong style='color: darkgoldenrod;'>${asset_name}</strong><br>`;

        const imageTag = this.mapBoxExpand ? data.image_path ? `<img src="https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/${data.image_path[0]}"  ><br>` :
            data.test_image_path ? `<img src="https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/${data.test_image_path}"  ><br>` : '' : '';
        this.mapBoxPopup = new mapboxgl.Popup()
            .setLngLat(coordinates)
            .setHTML(this.dashboardService.translate(description) + imageTag)
            .addTo(this.map);
        this.map.flyTo({
            center: [+data.longitude, +data.latitude],
            essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            zoom: this.map?.zoom < 12 ? this.map?.zoom : fromChainageMarker ? 11 : 16,
        });
    }

    get masterSites(): any[] {
        return this._masterSites;
    }

    public getMasterSiteInfo() {
        let count: any = localStorage.getItem('getMasterSiteInfoCallCount');
        if (count === null || count === undefined || count === "") {
            this.dashboardService.getMasterSiteInfo().subscribe(
                (res: any) => {
                    this.getMasterSiteInfoResponse(res.responseData[0].records, true);
                },
                (error) => { }
            );
        }
        else {
            let masterSites: any = localStorage.getItem("all-site-details");
            if (masterSites !== null && masterSites !== undefined && masterSites !== "") {
                this.getMasterSiteInfoResponse(JSON.parse(masterSites));
            }
        }
    }

    siteSelectCompareFn(x: any, y: any): boolean {
        return x && y ? x.site_name === y.site_name : x == y;
    }

    onMasterSiteSelectionChange() {
        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter(
            (data) => data.direction == 'Shoulder'
        )[0];
        this.isLhs = true;
        this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
        this.masterSiteSelectionChange.emit();
    }

    updateSiteQueryParamFilters(obj: any) {
        const queryParams = { ...this.route.snapshot.queryParams };
        for (let key in obj) {
            queryParams[key] = JSON.stringify(obj[key])
        }
        const navigationExtras: NavigationExtras = {
            queryParams,
            queryParamsHandling: 'merge',
        };
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
    }


    lhsSelectionChanged() {
        this.isLhs = !this.isLhs;
        this.isGoodSelected = false;
        this.isLhsRhsToggled = true;
        if (this.isLhs) {
            this.selectedSubSite = this.selectedMasterSite.sub_sites.filter(
                (data) => data.direction == 'Shoulder'
            )[0];
        } else {
            this.selectedSubSite = this.selectedMasterSite.sub_sites.filter(
                (data) => data.direction == 'Median'
            )[0];
        }
        this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
        this.masterSiteSelectionChange.emit();
    }

    reset(skipResetSubSite?: boolean) {
        this.selectedShiftData = undefined;
        //this.selectedAssetIdsForFilter = [];
        this.selectedAssetIdsForFilter = this.route.snapshot.queryParams.selectedAssetIdsForFilter ?
            JSON.parse(this.route.snapshot.queryParams.selectedAssetIdsForFilter) : [];
        this.selectedCategoryIdsForFilter = this.route.snapshot.queryParams.selectedCategoryIdsForFilter ?
            JSON.parse(this.route.snapshot.queryParams.selectedCategoryIdsForFilter) : [];
        /*Section filter changes*/
        /*this.selectedSections =  this.route.snapshot.queryParams.selectedSections ?
        JSON.parse( this.route.snapshot.queryParams.selectedSections): [];*/
        /**verification filter changes */
        this.verification_type = JSON.parse(localStorage.getItem('selectedFilterWithVerificationType')) ?
            JSON.parse(localStorage.getItem('selectedFilterWithVerificationType')) : [];
        this.chainageHighValue = undefined;
        this.chainageLowValue = undefined;
        this.defaultMinChainage = undefined;
        this.defaultMaxChainage = undefined;
        this.selectedDates = undefined;
        this.filters = [];
        this.periodFrom = undefined;
        this.periodTo = undefined;
        this.isInitialLoad = true;
        if (!skipResetSubSite) {
            if (this.selectedMasterSite) {
                /*LHS RHS changes,below line should be commented*/
                // this.selectedSubSite = this.selectedMasterSite.sub_sites.filter(
                //     (data) => data.direction == 'Shoulder'
                // )[0];
                /*LHS RHS changes*/
                if (localStorage.getItem('currentPage') === 'MasterDataLibrary') {
                    this.isMasterDataLHS = this.checkLocalStorage("isMasterDataLHS");
                    this.isMasterDataRHS = this.checkLocalStorage("isMasterDataRHS");
                    if (this.isMasterDataLHS && this.isMasterDataRHS) {
                        this.selectedSubSite = this.selectedMasterSite.sub_sites;
                    }
                    else if (this.isMasterDataRHS) {
                        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter((data) => data.direction == 'Median')[0];
                    }
                    else {
                        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter((data) => data.direction == 'Shoulder')[0];
                    }
                }
                else {
                    this.isShiftDataLHS = this.checkLocalStorage("isShiftDataLHS");
                    this.isShiftDataRHS = this.checkLocalStorage("isShiftDataRHS");

                    if (this.isShiftDataLHS && this.isShiftDataRHS) {
                        this.selectedSubSite = this.selectedMasterSite.sub_sites;
                    }
                    else if (this.isShiftDataRHS) {
                        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter((data) => data.direction == 'Median')[0];
                    }
                    else {
                        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter((data) => data.direction == 'Shoulder')[0];
                    }
                }
                this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
            }
        }
    }
    /*LHS RHS changes*/
    checkLocalStorage(value: string) {
        if (localStorage.getItem(value) !== null) {
            return localStorage.getItem(value) === "true" ? true : false;
        }
        return true;
    }

    openSiteSelectionDialog() {
        this.dialog.closeAll();
        if (this.siteSelectionDialogRef) {
            return;
        }
        this.siteSelectionDialogRef = this.dialog
            .open(SiteSelectionDialogComponent, {
                // minHeight: '60%',
                minWidth: '40%',
                hasBackdrop: false,
                closeOnNavigation: true,
            })
            .afterClosed()
            .subscribe(() => (this.siteSelectionDialogRef = undefined));
    }

    openDateFilterDialog() {
        this.dialog.closeAll();
        if (this.dateFilterDialogRef) {
            return;
        }
        this.dateFilterDialogRef = this.dialog
            .open(DateFilterDialogComponent, {
                // minHeight: '60%',
                // minWidth: '40%',
                closeOnNavigation: true,
                hasBackdrop: false,
            })
            .afterClosed()
            .subscribe((val: any) => {
                this.dateFilterDialogRef = undefined;
                // if(val === true){
                this.onFilterChange.emit([]);
                // }
            });
    }

    openAssetsFilterDialog() {
        this.dialog.closeAll();
        if (this.assetFilterDialogRef) {
            return;
        }
        this.assetFilterDialogRef = this.dialog
            .open(AssetsFilterDialogComponent, {
                height: '70%',
                width: '50%',
                closeOnNavigation: true,
                hasBackdrop: false,
            })
            .afterClosed()
            .subscribe(() => (this.assetFilterDialogRef = undefined));

        const extraSmallDialogSubscription = this.isExtraSmall.subscribe(
            (size) => {
                if (size.matches) {
                    this.assetFilterDialogRef.updateSize('90%', '50%');
                }
            }
        );
    }

    openChainageFilterDialog() {
        this.dialog.closeAll();
        if (this.assetFilterDialogRef) {
            return;
        }
        this.assetFilterDialogRef = this.dialog
            .open(ChainageFilterDialogComponent, {
                height: '50%',
                width: '40%',
                closeOnNavigation: true,
                hasBackdrop: false,
            })
            .afterClosed()
            .subscribe(() => (this.assetFilterDialogRef = undefined));

        const extraSmallDialogSubscription = this.isExtraSmall.subscribe(
            (size) => {
                if (size.matches) {
                }
            }
        );
    }

    setMinAndMaxChainages() {
        if (this.selectedSubSite.length > 1) {
            this.defaultMinChainage = this.selectedSubSite[0].start_chainage;
            this.defaultMaxChainage = this.selectedSubSite[0].end_chainage;
            this.chainageLowValue = this.defaultMinChainage;
            this.chainageHighValue = this.defaultMaxChainage;
            this.chainageValuesChangeEmitter.emit();
        }
        else {
            this.defaultMinChainage = this.selectedSubSite.start_chainage;
            this.defaultMaxChainage = this.selectedSubSite.end_chainage;
            this.chainageLowValue = this.defaultMinChainage;
            this.chainageHighValue = this.defaultMaxChainage;
            this.chainageValuesChangeEmitter.emit();
        }
    }

    openDownloadDialog() {
        this.dialog.closeAll();
        if (!this.downloadDialogRef) {
            this.downloadDialogRef = this.dialog
                .open(DownloadReportDialogComponent, {
                    // height: '40%',
                    width: '35%',
                    closeOnNavigation: true,
                    hasBackdrop: true,
                })
                .afterClosed()
                .subscribe(() => (this.downloadDialogRef = undefined));
        }
    }

    resetLHS() {
        this.isLhs = true;
    }

    public removeDateFilters() {
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['filterStartDate'];
        delete queryParams['filterEndDate'];
        this.isUnique = true;
        localStorage.setItem('isUniqueButton', this.isUnique.toString());
        const navigationExtras: NavigationExtras = {
            queryParams,
        };

        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
    }

    removeChainageFilters() {
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['chainageLowValue'];
        delete queryParams['chainageHighValue'];
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
    }

    removeSearchAnomalyIdFilters() {
        localStorage.setItem("AnomalyID", '');
        this.anomalyID = '';
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['searchAnomalyID'];
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    removeSearchMasterIdFilters() {
        localStorage.setItem("MasterID", '');
        this.masterID = '';
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['searchMasterID'];
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    applyRangeChainageFilters(filters) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            queryParams['chainageRangeValue'] = JSON.stringify(filters);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['chainageRangeValue'];
        }

        this.router.navigate([], navigationExtras);

        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });        
        this.onFilterChange.emit();
    }

    removeAssetFilters(filters) {
        const queryParams = { ...this.route.snapshot.queryParams };

        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            queryParams['selectedAssetIdsForFilter'] = JSON.stringify(filters);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['selectedAssetIdsForFilter'];
        }

        this.router.navigate([], navigationExtras);

        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    removeIssueTypeFilters(issueType: any = []) {
        const queryParams = { ...this.route.snapshot.queryParams };

        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (issueType && issueType.length) {
            queryParams['issueTypeValue'] = JSON.stringify(issueType);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['issueTypeValue'];
        }

        this.router.navigate([], navigationExtras);

        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    applySearchAnomalyIdFilters(value: any) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (value) {
            queryParams['searchAnomalyID'] = (value);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['searchAnomalyID'];
        }
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    applySearchMasterIdFilters(value: any) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (value) {
            queryParams['searchMasterID'] = (value);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['searchMasterID'];
        }
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    applyAssetFilters(filters, issueType: any = []) {
        const queryParams = { ...this.route.snapshot.queryParams };

        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            queryParams['selectedAssetIdsForFilter'] = JSON.stringify(filters);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['selectedAssetIdsForFilter'];
        }
        if (issueType && issueType.length) {
            queryParams['issueTypeValue'] = JSON.stringify(issueType);
            navigationExtras.queryParamsHandling = 'merge';
        } else {
            delete queryParams['issueTypeValue'];
        }

        this.router.navigate([], navigationExtras);

        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    removeAllFilter() {
        const queryParams = { ...this.route.snapshot.queryParams };

        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        delete queryParams['selectedAssetIdsForFilter'];
        delete queryParams['selectedCategoryIdsForFilter'];
        this.selectedCategoryIdsForFilter = [];
        delete queryParams['chainageLowValue'];
        delete queryParams['chainageHighValue'];
        delete queryParams['filterStartDate'];
        delete queryParams['filterEndDate'];
        delete queryParams['chainageRangeValue'];
        delete queryParams['searchAnomalyID'];
        delete queryParams['searchMasterID'];
        this.isUnique = true;
        this.selectedChainageRanges = [];
        delete queryParams['issueTypeValue'];
        this.selectIssueType = [];
        localStorage.setItem('selectedIssueType', '');
        localStorage.setItem('selectedChainageRanges', '');
        localStorage.setItem('isUniqueButton', this.isUnique.toString());
        localStorage.setItem("AnomalyID", '');
        this.anomalyID = '';
        localStorage.setItem("MasterID", '');
        this.masterID = '';
        delete queryParams['selectedVerificationForFilter']; /*verification filter changes*/
        //delete queryParams['selectedSections']; /*section filter changes */
        this.router.navigate([], navigationExtras);
        localStorage.setItem("isDay", 'false');
        localStorage.setItem("isNight", 'false');
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.verification_type = this.verification_type ? [] : this.verification_type; /*verification filter changes*/
        this.selectedSections = this.selectedSections ? [] : this.selectedSections;/*section filter changes */
        this.onFilterChange.emit();
    }
    /*verification filter changes*/
    openVerificationFilterDialog() {
        this.dialog.closeAll();
        if (this.verificationFilterDialogRef) {
            return;
        }
        this.verificationFilterDialogRef = this.dialog
            .open(VerificationStatusFilterDialogComponent, {
                // height: '70%',
                width: '40%',
                closeOnNavigation: true,
                hasBackdrop: false,
            })
            .afterClosed()
            .subscribe(() => (this.verificationFilterDialogRef = undefined));

        const extraSmallDialogSubscription = this.isExtraSmall.subscribe(
            (size) => {
                if (size.matches) {
                    this.verificationFilterDialogRef.updateSize('90%', '50%');
                }
            }
        );
    }

    applyVerificationFilters(filters, remove: boolean = false) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            filters = (filters === 'Staff Verification') ? 'STAFF_VERFICATION' :
                (filters === 'AI Validation') ? 'AI_VALIDATION' : 'AI_REJECTED';
            queryParams['selectedVerificationForFilter'] = JSON.stringify(filters);
            navigationExtras.queryParamsHandling = 'merge';
            if (remove) {
                const index = this.verification_type.findIndex((element) => element === filters);
                this.verification_type.splice(index, 1);
            }
        }
        else {
            delete queryParams['selectedVerificationForFilter'];
        }
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    removeVerificationFilters() {
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['selectedVerificationForFilter'];
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        this.router.navigate([], navigationExtras);
        this.onFilterChange.emit();
    }
    /*section filter changes*/
    /*openSectionFilterDialog(){
        this.dialog.closeAll();
        if (this.sectionFilterDialogRef) {
            return;
        }
        this.sectionFilterDialogRef = this.dialog
            .open(SectionSelectionDialogComponent, {
               // height: '70%',
                width: '40%',
                closeOnNavigation: true,
                hasBackdrop: false,
            })
            .afterClosed()
            .subscribe(() => (this.sectionFilterDialogRef = undefined));

        const extraSmallDialogSubscription = this.isExtraSmall.subscribe(
            (size) => {
                if (size.matches) {
                    this.sectionFilterDialogRef.updateSize('90%', '50%');
                }
            }
        );
    }
    applySectionFilters(filters,remove:boolean = false) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            if(remove){
                const index = this.selectedSections.findIndex((element) => element === filters);
                this.selectedSections.splice(index, 1);
            }
            queryParams['selectedSections'] = JSON.stringify(this.selectedSections);
            navigationExtras.queryParamsHandling = 'merge';
        }
        else {
            delete queryParams['selectedSections'];
        }
        this.router.navigate([], navigationExtras);
        this.onFilterChange.emit();                
    }

    removeSectionFilters() {
        
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['selectedSections'];
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        this.router.navigate([], navigationExtras);
        this.onFilterChange.emit();                
    }*/
    /**change password */
    /*openChangePasswordDialog() {
        this.dialog.closeAll();
        if (!this.changePasswordDialogRef) {
            this.changePasswordDialogRef = this.dialog
                .open(ChangePasswordDialogComponent, {
                    // height: '40%',
                    width: '20%',
                    closeOnNavigation: true,
                    hasBackdrop: true,
                })
                .afterClosed()
                .subscribe(() => (this.changePasswordDialogRef = undefined));
        }
    }*/

    /*LHS RHS changes*/
    lhsSelectedAnomaly() {
        this.isLhs = true;
        this.isGoodSelected = false;
        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter((data) => data.direction == 'Shoulder')[0];
        this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
        this.masterSiteSelectionChange.emit();
    }

    rhsSelectedAnomaly() {
        this.isLhs = false;
        this.isGoodSelected = false;
        this.selectedSubSite = this.selectedMasterSite.sub_sites.filter((data) => data.direction == 'Median')[0];
        this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
        this.masterSiteSelectionChange.emit();
    }

    lhsrhsSelectedAnomaly() {
        this.isLhs = false;
        this.isGoodSelected = false;
        this.selectedSubSite = this.selectedMasterSite.sub_sites;
        this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
        this.masterSiteSelectionChange.emit();
    }
    //sort assets/sitename (filter) in ascending order
    sortAssetsAscendingOrder(asset_types: any) {
        //sorting asset_type
        asset_types.sort((a, b) =>
            a.asset_type_name > b.asset_type_name ? 1 : -1
        );
        //sorting assets
        asset_types.forEach((asset) => {
            asset.assets.sort((a, b) =>
                a.asset_name > b.asset_name ? 1 : -1
            );
        })
    }

    applyCategoryFilters(filters: any = []) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            queryParams['selectedCategoryIdsForFilter'] = JSON.stringify(filters);
            navigationExtras.queryParamsHandling = 'merge';
        }
        else {
            delete queryParams['selectedCategoryIdsForFilter'];
        }
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    removeCategoryFilters(filters) {
        const queryParams = { ...this.route.snapshot.queryParams };
        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        if (filters && filters.length) {
            queryParams['selectedCategoryIdsForFilter'] = JSON.stringify(filters);
            navigationExtras.queryParamsHandling = 'merge';
        }
        else {
            delete queryParams['selectedCategoryIdsForFilter'];
        }
        this.router.navigate([], navigationExtras);
        // this.router.navigate([], navigationExtras).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // });
        this.onFilterChange.emit();
    }

    openCategoryFilterDialog() {
        this.dialog.closeAll();
        if (this.categoryFilterDialogRef) {
            return;
        }
        this.categoryFilterDialogRef = this.dialog
            .open(CategoryFilterDialogComponent, {
                height: '40%',
                width: '25%',
                closeOnNavigation: true,
                hasBackdrop: false,
            })
            .afterClosed()
            .subscribe(() => (this.categoryFilterDialogRef = undefined));

        const extraSmallDialogSubscription = this.isExtraSmall.subscribe(
            (size) => {
                if (size.matches) {
                    this.categoryFilterDialogRef.updateSize('90%', '50%');
                }
            }
        );
    }

    public getAssetTypesInAssets() {
        let count: any = localStorage.getItem('getAssetTypesInAssetsCallCount');
        if (count === null || count === undefined || count === "") {
            this.dashboardService.getAssetTypesInAssets().subscribe(
                (res: any) => {
                    localStorage.setItem('getAssetTypesInAssetsCallCount', '1');
                    let assetTypesInAssets: any = [...res.responseData[0].records];
                    //A default Master Image for assets like linear which doesn't have master images.
                    localStorage.setItem('AssetTypesInAssets', JSON.stringify(assetTypesInAssets));
                    // this.processShiftDataSummary();
                },
                (error) => {
                    this.alertService.error(error.responseStatus.statusDescription);
                }
            );
        }
    }

    getCategoryData() {
        // let count : any = localStorage.getItem('getCategoryDataCallCount');
        // if (count === null || count === undefined || count === "") {
        // let selectedSiteDetails = JSON.parse(localStorage.getItem('SelectedMasterSite'));
        let site_name: any = [];
        if (this.selectedSubSite && this.selectedSubSite.length === 2) {
            site_name = this.selectedSubSite[0].site_name;
        }
        else {
            site_name = this.selectedSubSite.site_name;
        }
        this.dashboardService.getCategoryData(site_name).subscribe(
            (res: any) => {
                localStorage.setItem('getCategoryDataCallCount', '1');
                if (res && res.responseData && res.responseData[0] && res.responseData[0].records) {
                    localStorage.setItem('categories', JSON.stringify(res.responseData[0].records));
                }
            },
            (error) => {
                this.alertService.error(error.responseStatus.statusDescription);
            }
        );
        // }
    }

    public getIssueTypeData() {
        // let count : any = localStorage.getItem('getIssueTypeDataCallCount');
        // if (count === null || count === undefined || count === "") {
        let site_id: any = [];
        if (this.selectedSubSite && this.selectedSubSite.length === 2) {
            site_id.push(this.selectedSubSite[0].site_id);
        }
        else if (this.selectedSubSite && this.selectedSubSite.site_id) {
            site_id.push(this.selectedSubSite.site_id);
        }
        this.dashboardService.getIssueTypeData(site_id).subscribe(
            (res: any) => {
                localStorage.setItem('getIssueTypeDataCallCount', '1');
                localStorage.setItem('issueTypeData', JSON.stringify(res));
            },
            (error) => {
                this.alertService.error(error.responseStatus.statusDescription);
            }
        );
        // }
    }

    removeAllFilters() {
        const queryParams = { ...this.route.snapshot.queryParams };

        const navigationExtras: NavigationExtras = {
            queryParams,
        };
        delete queryParams['selectedAssetIdsForFilter'];
        delete queryParams['selectedCategoryIdsForFilter'];
        this.selectedCategoryIdsForFilter = [];
        delete queryParams['chainageLowValue'];
        delete queryParams['chainageHighValue'];
        delete queryParams['filterStartDate'];
        delete queryParams['filterEndDate'];
        delete queryParams['chainageRangeValue'];
        delete queryParams['searchAnomalyID'];
        delete queryParams['searchMasterID'];
        this.isUnique = true;
        this.selectedChainageRanges = [];
        delete queryParams['issueTypeValue'];
        this.selectIssueType = [];
        localStorage.setItem('selectedIssueType', '');
        localStorage.setItem('selectedChainageRanges', '');
        localStorage.setItem('isUniqueButton', this.isUnique.toString());
        localStorage.setItem("AnomalyID", '');
        this.anomalyID = '';
        localStorage.setItem("MasterID", '');
        this.masterID = '';
        localStorage.setItem("isDay", 'false');
        localStorage.setItem("isNight", 'false');
        delete queryParams['selectedVerificationForFilter']; /*verification filter changes*/
        //delete queryParams['selectedSections']; /*section filter changes */
        this.router.navigate([], navigationExtras);
        this.verification_type = this.verification_type ? [] : this.verification_type; /*verification filter changes*/
        this.selectedSections = this.selectedSections ? [] : this.selectedSections;/*section filter changes */
    }

    getMasterSiteInfoResponse(res: any, val: boolean = false) {
        this._masterSites = res;
        localStorage.setItem("all-site-details", JSON.stringify(this._masterSites));
        this._masterSites = this._masterSites.map((site) => site[0]);
        //Section filter changes 
        //this.sections = this._masterSites; // should be changed with section data instead of site data
        setTimeout(() => {
            let queryParams = this.route.snapshot.queryParams;
            if (queryParams.selectedMasterSite) {
                this.selectedMasterSite = JSON.parse(
                    queryParams.selectedMasterSite
                );

            } else {
                this.selectedMasterSite = this.masterSites[0];
            }
            localStorage.setItem('NumberOfSubSitesForSelectedMasterSite', this.masterSites[0].sub_sites.length);
            localStorage.setItem('SelectedMasterSite', JSON.stringify(this.selectedMasterSite));
            this.masterSiteSelection.emit();
            this.selectedMasterSite.current_status = 1;
            this.selectedMasterSite.master_image_path =
                this.selectedMasterSite.image_path;
            //to check if dta.direction is LHS/RHS, then it will be changed to Shoulder/Median- this is an temp change,during login --it should always have shoulder/median value itself
            this.selectedMasterSite.sub_sites.forEach((data) => {
                data.direction = (data.direction === "LHS") ? "Shoulder" : (data.direction === "RHS") ? "Median" : data.direction;
            })
            if (queryParams.selectedSubSite) {
                this.selectedSubSite = JSON.parse(
                    queryParams.selectedSubSite
                );
            } else {
                //By Default selecting the LHS Side
                this.selectedSubSite =
                    this.selectedMasterSite.sub_sites.filter(
                        (data) => data.direction == 'Shoulder'
                    )[0];
            }

            if (this.selectedMasterSite && this.selectedMasterSite.site_name != null && this.selectedMasterSite.site_name != undefined && this.selectedMasterSite.site_name != "") {
                this.selectedSiteToDisplaySiteDetails = this.selectedMasterSite.site_name;
                this.siteSelectionEvent.emit();
                this.dashboardService.getLanguagesDetails(this.selectedMasterSite.sub_sites[0].site_id );
            }
            this.updateSiteQueryParamFilters({ selectedMasterSite: this.selectedMasterSite, selectedSubSite: this.selectedSubSite })
            this.isLhs =
                this.selectedSubSite && this.selectedSubSite.direction == 'Shoulder' ? true : false;
            if (this.selectedMasterSite.sub_sites[0].site_id === 178 || this.selectedMasterSite.sub_sites[0].site_id === 179) {
                this.chainageValues = [{ index: 0, chainage: [414, 418.989] },
                { index: 1, chainage: [0, 62.1] }
                ]
            }
            else if (this.selectedMasterSite.sub_sites[0].site_id === 268 || this.selectedMasterSite.sub_sites[0].site_id === 269) {
                this.chainageValues = [{ index: 0, chainage: [414, 419.8] },
                { index: 1, chainage: [0, 63.5] }
                ]
            }
            localStorage.setItem("OriginalChainageValues", JSON.stringify(this.chainageValues));
            if (val) {
                this.getCategoryData();
                this.masterSiteSelectionChange.emit();
            }
            // else {
            //     this.refreshChange.emit();
            // }
        });

    }

    expandMapChange() {
        return true;
    }

    expand: boolean = false;

    displayLeafletMap(): boolean {
        return this.isLeafLetMap;
    }

    leafletExpand: boolean = false;

    leafletExpandVal(): boolean {
        return !this.leafletExpand;
    }

    OSMExpand: boolean = false;

    OSMExpandVal(): boolean {
        return !this.OSMExpand;
    }

    displayMapBox(): boolean {
        return this.isMapBox;
    }

    mapBoxExpand: boolean = false;

    mapBoxExpandVal(): boolean {
        return !this.mapBoxExpand;
    }

    // ✅ Function to toggle fullscreen mode
    expandSelectedMap(): void {
        this.expand = !this.expand;
        localStorage.setItem("isMapExpand", this.expand.toString());
        this.showMaps = false;
        if (this.isMapBox) {
            this.mapBoxExpand = !this.mapBoxExpand
            localStorage.setItem("mapBoxExpand", this.mapBoxExpand.toString());;
            this.expandMap.emit(this.mapBoxExpand);
            if (this.mapBoxPopup && this.selectedShiftData) {
                this.onMarkerClick(this.selectedShiftData);
            }
            setTimeout(() => {
                if (this.map) {
                    this.map.resize(); // 🔥 Redraws the map with new dimensions
                }
            }, 100);
        }
        if (this.isOpenStreetMap) {
            this.OSMExpand = !this.OSMExpand;
            localStorage.setItem("OSMExpand", this.OSMExpand.toString());
            this.onOSMMarkerClick(this.selectedShiftData);
        }
        if (this.isLeafLetMap) {
            this.leafletExpand = !this.leafletExpand;
            localStorage.setItem("leafletExpand", this.leafletExpand.toString());
        } // Slight delay; adjust if you have animations
    }

    showLeafletMap() {

        // if (!this.mapBoxExpand) {
        localStorage.setItem("selectedMap", 'leafLetMap');
        this.isLeafLetMap = true;
        this.isMapBox = false;
        this.isOpenStreetMap = false;
        setTimeout(() => {
            this.loadMap.emit();
        }, 500);
        // }
    }

    showMapBoxMap() {
        localStorage.setItem("selectedMap", 'mapBox');
        this.isLeafLetMap = false;
        this.isMapBox = true;
        this.isOpenStreetMap = false;
        setTimeout(() => {
            this.loadMap.emit();
        }, 500);
    }

    showOpenStreetMap() {

        // if (!this.OSMExpand) {
        localStorage.setItem("selectedMap", 'openStreet');
        this.isLeafLetMap = false;
        this.isMapBox = false;
        this.isOpenStreetMap = true;
        setTimeout(() => {
            this.loadMap.emit();
        }, 500);
        // }
    }

    expandShrinkMap() {
        this.showMaps = false;
        this.leafletExpand = !this.leafletExpand;
        this.OSMExpand = !this.OSMExpand;
        this.mapBoxExpand = !this.mapBoxExpand;
        this.expand = !this.expand;
        setTimeout(() => {
            this.map.invalidateSize(); // Force Leaflet to resize
        }, 300); // Delay to allow CSS changes to apply
    }

    showOSMap() {
        // if (!this.leafletExpand) {
        localStorage.setItem("selectedMap", 'openStreet');
        this.isLeafLetMap = false;
        this.isMapBox = false;
        this.isOpenStreetMap = true;
        setTimeout(() => {
            this.loadMap.emit();
        }, 500);
        // }
    }

    showMapBox() {
        // if (!this.leafletExpand) {
        localStorage.setItem("selectedMap", 'mapBox');
        this.isLeafLetMap = false;
        this.isOpenStreetMap = false;
        this.isMapBox = true;
        setTimeout(() => {
            this.loadMap.emit();
        }, 500);
        // }
    }

    onOSMMarkerClick(data: any) {
        const coordinates: any = {};
        coordinates.lat = data.latitude;
        coordinates.lng = data.longitude;
        let image: any;
        let master_image : any;
        if( data?.master_image_path?.length == 1 || data?.master_image_path?.length == 2 || data?.master_image_path?.length == 3){
            master_image = data?.master_image_path[0];
        }
        else{
            master_image = data?.master_image_path;
        }
        if (data.current_status === 2) {
            image = this.OSMExpand
                ? `<img src="https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/${data?.test_image_path}"  >`
                : '';
        }
        else {
            image = this.OSMExpand
                ? `<img src="https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/${master_image}"  >`
                : '';
        }
        if (this.popup) {
            this.popup.remove();
        }

        if (data) {
            this.popup = new maplibregl.Popup()
                .setLngLat(coordinates)
                .setHTML(`<strong>${this.dashboardService.translate(data.asset_name)}</strong><br/>${image}`)
                .addTo(this.OSMap);
        }

        this.OSMap.flyTo({
            center: [+data.longitude, +data.latitude],
            essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            zoom: this.OSMap?.zoom < 12 ? 11 : 16,
        });

    }



    onMapClick() {
        let currentPage = localStorage.getItem('currentPage');
        if (currentPage === 'ShiftDataAnalysis') {
            const index = this.allShiftData.findIndex((value) => (value.row_id === this.selectedShiftData.row_id));
            if (index === 0) {
                this.anomalySelectedIndex = index;
            }
            else if (index < 0) {
                this.anomalySelectedIndex = 0;
            }
            else if (index === this.allShiftData.length - 1) {
                this.anomalySelectedIndex = this.allShiftData.length - 1;
            }
            else if (index < this.allShiftData.length) {
                this.anomalySelectedIndex = index;
            }
            this.getMarkerData(this.selectedShiftData);
        }
        else {
            const index = this.allShiftData.findIndex((value) => (value.id === this.selectedShiftData.id));
            if (index === 0) {
                this.assetSelectedIndex = index;
            }
            else if (index < 0) {
                this.assetSelectedIndex = 0;
            }
            else if (index === this.allShiftData.length - 1) {
                this.assetSelectedIndex = this.allShiftData.length - 1;
            }
            else if (index < this.allShiftData.length) {
                this.assetSelectedIndex = index;
            }
        }
    }
}
